'use client'

/* eslint-disable react/function-component-definition */
/* eslint-disable @typescript-eslint/no-floating-promises */
import Image from 'next/image'
import { segmentEventCommonPropFuncAckoDrive } from '@utils/segmentProperties'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { StyledButton, CallBackIconWrapper, WidgetWrapper, ContentWrapper, Heading, SubHeading } from './styles'
import { BEST_CAR_DEALS_PROMISE, CALLBACK_WIDGET_IMAGE_SRC, EXPLORE_NEW_CARS, LOOKING_FOR_NEW_CAR } from './constants'

export default function CallbackDesktopWidget({ onClickHandler }) {
  return (
    <WidgetWrapper>
      <ContentWrapper>
        <Heading>{LOOKING_FOR_NEW_CAR}</Heading>
        <SubHeading>{BEST_CAR_DEALS_PROMISE}</SubHeading>
      </ContentWrapper>

      <CallBackIconWrapper>
        <Image src={CALLBACK_WIDGET_IMAGE_SRC} alt="Callback Widget Desktop Icon" width={396} height={160} priority />
      </CallBackIconWrapper>
      <StyledButton
        onClick={() => {
          const properties = segmentEventCommonPropFuncAckoDrive({ pageType: '' })
          trackEvent('tap_btn_explore_new_cars', {
            ...properties,
          })
          onClickHandler()
        }}>
        {EXPLORE_NEW_CARS}
      </StyledButton>
    </WidgetWrapper>
  )
}
